import axios from '../axios';
// import router from '@/router/index';

export default {
  namespaced: true,
  state: () => ({}),
  actions: {
    async list() {
      try {
        const response = await axios.get(`/carousels`);
        return response.data;
      } catch(error) {
        const { response } = error;
        
        if(response) {
          throw(response.data);
        } else {
          throw({ message: 'เซิฟเวอร์มีปัญหาในขณะนี้ กรุณาลองใหม่ภายหลัง' });
        }
      }
    },
    async update(_, payload) {
      try {
        const { data } = await axios.post(`/carousels/${payload.id}`, payload.form_data);
        return data;
      } catch(error) {
        const { response } = error;
        
        if(response) {
          throw(response.data);
        } else {
          throw({ message: 'เซิฟเวอร์มีปัญหาในขณะนี้ กรุณาลองใหม่ภายหลัง' });
        }
      }
    },
    async delete(_, id) {
      try {
        const { data } = await axios.delete(`/carousels/${id}`);
        return data;
      } catch(error) {
        const { response } = error;
        
        if(response) {
          throw(response.data);
        } else {
          throw({ message: 'เซิฟเวอร์มีปัญหาในขณะนี้ กรุณาลองใหม่ภายหลัง' });
        }
      }
    }
  },
  mutations: {
    SET_FORM_TYPES(state, data) { state.form_groups = data }
  }
    
}